/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getMaintenance } from '../fn/maintenance/get-maintenance';
import { GetMaintenance$Params } from '../fn/maintenance/get-maintenance';

@Injectable({ providedIn: 'root' })
export class MaintenanceApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getMaintenance()` */
  static readonly GetMaintenancePath = '/api/v1';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMaintenance()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMaintenance$Response(params?: GetMaintenance$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return getMaintenance(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMaintenance$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMaintenance(params?: GetMaintenance$Params, context?: HttpContext): Observable<void> {
    return this.getMaintenance$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
